import { render, staticRenderFns } from "./ApiDetails.vue?vue&type=template&id=170932fa&scoped=true&"
import script from "./ApiDetails.vue?vue&type=script&lang=ts&"
export * from "./ApiDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ApiDetails.vue?vue&type=style&index=0&id=170932fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170932fa",
  null
  
)

export default component.exports